import { authHref } from '@/shared/lib/auth-return';
import clsx from 'clsx';
import Link from 'next/link';

type AuthTabsProps = {
	active: 'login' | 'register';
	redirectPath?: string;
};

export function AuthTabs({ active = 'login', redirectPath }: AuthTabsProps) {
	const links = [
		{
			key: 'login',
			href: authHref('/login', redirectPath),
			text: 'Вход',
		},
		{
			key: 'register',
			href: authHref('/register', redirectPath),
			text: 'Регистрация',
		},
	];
	return (
		<div className="grid grid-cols-2">
			{links.map((link) => (
				<Link
					key={link.key}
					className={clsx('border-b py-3 text-center', {
						'border-b-accent text-black': active === link.key,
						'border-b-gray-4 text-gray-3': active !== link.key,
					})}
					href={link.href}
				>
					{link.text}
				</Link>
			))}
		</div>
	);
}
